[
  {
    "code" : "N830",
    "description" : "Goederenaangifte ten uitvoer"
  }
]
